import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { Title } from '@angular/platform-browser';

import { AuthHttpClient } from '../../../providers/auth-http.service';
import { AuthService } from '../../../providers/auth.service';
import { SharedClientService } from '../shared/services/shared-client.service';
import { IApp } from '../../../app';


export class ProfileComponent implements IApp, OnInit {

	public client: any;
	public state: any = {
		profile: {
			loading: false,
			done: false
		}
	};

	public clientForm = this.fb.group({
		contactName: ['', Validators.required],
		contactPosition: ['', Validators.required],
		contactPhoneNumber: ['']
	});

	constructor(
		private titleService: Title,
		private authHttp: AuthHttpClient,
		private fb: FormBuilder,
		private authService: AuthService,
		private sharedClientService: SharedClientService) {
			this.setAppTitle();
	}

	// Lifecycle Events
	public ngOnInit(): void {
		this.getClient();
	}

	// Events
	public setAppTitle(): void  {
		this.titleService.setTitle('hackajob.co - Profile');
	}

	public onProfileSettingsSubmit(): void {
		this.state.profile.loading = true;
		const formValue = this.clientForm.value;

		let editedClient: any = {
			contact_name: formValue.contactName,
			contact_position: formValue.contactPosition,
			contact_phone_number: formValue.contactPhoneNumber
		};

		this.sharedClientService.postClient(String(this.authService.userId), editedClient).subscribe(
			(resp) => {
				this.getClient(true);
			}
		);
	}

	// Service calls
	private getClient(changes?: boolean): void {
		this.sharedClientService.get(this.authService.userId).subscribe(
			(client) => {
				this.client = this.fetchClient(client);
				this.state.profile.loading = false;
				if (changes) {
					this.state.profile.done = true;
					setTimeout(() => {
						this.state.profile.done = false;
					}, 2000);
				}
				if (!changes) {
					this.updateForm();
				}
			}
		);
	}

	private updateForm() {
		this.clientForm.get('contactName').setValue(this.client.contact_name);
		this.clientForm.get('contactPosition').setValue(this.client.contact_position);
		this.clientForm.get('contactPhoneNumber').setValue(this.client.contact_phone_number);
	}

	// Helpers
	private fetchClient(client: any): any {
		if (!client.contact_phone_number) {
			client.contact_phone_number = '';
		}

		return client;
	}
static ctorParameters() { return [ { type: Title }, { type: AuthHttpClient }, { type: FormBuilder }, { type: AuthService }, { type: SharedClientService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/profile/profile.component.ts